import React from "react"
import { BookOpen, Briefcase, GraduationCap, HelpCircle, MessageSquare, Users, Instagram, Twitter } from "lucide-react"
import { Link } from "react-router-dom"

export function Sidebar() {
  return (
    <aside className="fixed top-0 left-0 z-40 w-64 h-screen pt-16 bg-white border-r border-gray-200">
      <div className="h-full px-3 pb-4 overflow-y-auto">
        <ul className="space-y-2 font-medium mt-4">
          <li><Link to="#" className="flex items-center p-2 text-[#04236B] rounded-lg hover:bg-[#c9dbff73]"><MessageSquare className="w-5 h-5" /><span className="ms-3">Counseling</span></Link></li>
          <li><Link to="#" className="flex items-center p-2 text-[#04236B] rounded-lg hover:bg-[#c9dbff73]"><BookOpen className="w-5 h-5" /><span className="ms-3">Events</span></Link></li>
          <li><Link to="#" className="flex items-center p-2 text-[#04236B] rounded-lg hover:bg-[#c9dbff73]"><GraduationCap className="w-5 h-5" /><span className="ms-3">AI Resume Maker</span></Link></li>
          <li><Link to="#" className="flex items-center p-2 text-[#04236B] rounded-lg hover:bg-[#c9dbff73]"><Briefcase className="w-5 h-5" /><span className="ms-3">AI Job</span></Link></li>
          <li><Link to="#" className="flex items-center p-2 text-[#04236B] rounded-lg hover:bg-[#c9dbff73]"><Users className="w-5 h-5" /><span className="ms-3">Community</span></Link></li>
          <li><Link to="#" className="flex items-center p-2 text-[#04236B] rounded-lg hover:bg-[#c9dbff73]"><HelpCircle className="w-5 h-5" /><span className="ms-3">Support</span></Link></li>
        </ul>

        <div className="pt-5 mt-5 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-2 px-2">Follow us</p>
          <div className="flex space-x-2 px-2">
            <Link to="#" className="text-[#04236B] hover:text-[#04236B]"><Instagram className="w-5 h-5" /></Link>
            <Link to="#" className="text-[#04236B] hover:text-[#04236B]"><Twitter className="w-5 h-5" /></Link>
          </div>
        </div>
      </div>
    </aside>
  )
}
